import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../Component/Loading";
import moment from "moment-timezone";
import useMuiCompontent from "../../Hooks/useMuiCompontent";
import { RoleTitle } from "../../Context/constants";
import { FaArrowLeft } from "react-icons/fa";
import { GET_CHECKOUT_SLIP_DETAILS, GET_CHECKOUT_SLIP_GRAPHS_DETAILS } from "../Repository/AppointmentsRepo";
import useReduxData from "../../Hooks/useReduxData";
import { convertToBase64, Dosage } from "../../Utils/Utils";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts";
import { clinicPictures, SignatureURL } from "../../Context/api";
import html2pdf from 'html2pdf.js';
import { Avatar } from "@mui/material";
const CheckoutSlip = ({ type }) => {
    const [loader, setLoader] = useState(false)
    const { id, subpatientId, ApptId } = useParams()
    const [base64Image, setBase64Image] = useState({
        clinicImage: null,
        Signature: null
    });
    const [checkoutSlipData, setcheckoutSlipData] = useState({})
    const [checkoutSlipGraphData, setcheckoutSlipGraphData] = useState({})
    const [checkoutCount, setcheckoutCount] = useState(0)
    const [shouldBreakPage, setShouldBreakPage] = useState(false);
    const { CustomButton } = useMuiCompontent()
    const { reduxData: userData } = useReduxData("userDataRDX")
    const { reduxData: MemberType, } = useReduxData("SubMemberTypeRDX")
    const navigate = useNavigate()
    const componentRef = useRef();
    const pageLength = useRef();

    const handlePrint = () => {
        const element = componentRef.current;
        html2pdf()
            .set({
                margin: 8,
                filename: `${checkoutSlipData?.patientId}_checkout_slip.pdf`,
                image: { type: 'jpeg', quality: 1 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(element)
            .save();
    };
    const getListSelectedMedicines = async () => {
        setLoader(true)
        let payload = {
            patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
            providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
            appointmentId: ApptId,
            roleTitle: userData.roleTitle,
        }

        try {
            let response = await GET_CHECKOUT_SLIP_DETAILS(payload)
            setcheckoutSlipData(response.data)
            setLoader(false)
        } catch (error) {
            toast.error(error.message);
            setLoader(false)
            setcheckoutSlipData({})
        }
    }
    const getGraphDetails = async () => {
        setLoader(true)
        let payload = {
            patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
            providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
            roleTitle: userData.roleTitle,
        }

        try {
            let response = await GET_CHECKOUT_SLIP_GRAPHS_DETAILS(payload)
            setcheckoutSlipGraphData(response.data)
            setLoader(false)
            setcheckoutCount(response?.total)
        } catch (error) {
            setLoader(false)
            setcheckoutSlipGraphData({})
            setcheckoutCount(0)
        }
    }

    useEffect(() => {
        getListSelectedMedicines()
        getGraphDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const doctorDegrees = checkoutSlipData?.doctorDegrees?.map((item, index) => <span key={index} >{item?.degree}{checkoutSlipData?.doctorDegrees?.length > index + 1 ? ', ' : ''}</span>)
    const doctorName = `${checkoutSlipData?.doctorTitle ?? "-"} ${checkoutSlipData?.doctorFirstName ?? "-"} ${checkoutSlipData?.doctorLastName ?? "-"}`
    const { insightsPatientTemp = [], insightsPatientBp = [], insightsPatientBMI = [] } = checkoutSlipGraphData
    const fullFirstAddress1 = [
        checkoutSlipData?.street

    ].filter(Boolean).join(", ");
    const fullFirstAddress = [
        checkoutSlipData?.address,

    ].filter(Boolean).join(", ");
    const fullLastAddress = [
        checkoutSlipData?.city,
        checkoutSlipData?.state,
        checkoutSlipData?.country,
        checkoutSlipData?.zipCode
    ].filter(Boolean).join(", ");

    const fullPatientAddress = [
        checkoutSlipData?.patientCity,
        checkoutSlipData?.patientState,
    ].filter(Boolean).join(", ");


    useEffect(() => {
        const loadImages = async () => {
            const updatedBase64 = { clinicImage: null, Signature: null };

            if (checkoutSlipData?.clinicImage) {
                try {
                    updatedBase64.clinicImage = await convertToBase64(clinicPictures + checkoutSlipData.clinicImage);
                } catch (e) {
                    console.error("Failed to convert clinic image:", e);
                }
            }

            if (checkoutSlipData?.signature) {
                try {
                    updatedBase64.Signature = await convertToBase64(SignatureURL + checkoutSlipData?.signature);
                } catch (e) {
                    console.error("Failed to convert signature:", e);
                }
            }

            setBase64Image(updatedBase64);
        };
        if (pageLength.current) {
            const height = pageLength.current.offsetHeight;
            console.log(height, "height")
            if (height > 700) setShouldBreakPage(true);
        }

        loadImages();
    }, [checkoutSlipData]);


    return (
        <>
            {loader && <Loading />}
            <div className="common-component-box">
                <header className="body_header" >
                    <div className="d-flex justify-content-start align-items-center">
                        <FaArrowLeft className="me-2 cursor"
                            // onClick={() => {
                            //     if (type === "Patients") {
                            //         navigate(`/patients/${id}/checkout-slip`)
                            //     } else {
                            //         navigate(`/patients/${id}/sub-members/${subpatientId}/checkout-slip`)
                            //     }
                            // }} 
                            onClick={() => navigate(-1)}
                        />
                        <h2 className='page_name'>Checkout Slip</h2>
                    </div>
                </header>
                <div className="row common-white-bg-box mx-0 shadow d-flex align-content-start  position-relative px-2">
                    <div className='p-0 pt-2 text_box_height' >
                        <div className="row px-0 mx-0 px-5">
                            <div className="col-3 ms-auto d-flex justify-content-end pe-0 mb-2">
                                <CustomButton
                                    onClick={handlePrint}
                                    variant="contained" >print</CustomButton>
                            </div>
                            <div className=" w-100 bg p-0 checkout_clip_container  bgimg " ref={componentRef}>
                                <div ref={pageLength}>
                                    <div className=" d-flex  justify-content-between w-100 ">
                                        <div className="d-flex justify-content-between flex-column">
                                            <div className="">
                                                <h4 >{doctorName}</h4>
                                                <h5 className="mb-1" ><span>{doctorDegrees}</span> | Reg No:{checkoutSlipData?.regNo ?? "N/A"} |</h5>
                                                <h5 className="mb-1" >Mob. No. {checkoutSlipData?.doctorMobile ?? "N/A"}</h5>
                                            </div>
                                            <div className=" mt-3">
                                                <h5 className="mb-1"><b>P. ID: {checkoutSlipData?.patientId ?? ""} - {(checkoutSlipData?.patientFirstName ?? "") + " " + (checkoutSlipData?.patientLastName ?? "")}</b></h5>
                                                <h5 className="mb-1">Address: {fullPatientAddress}</h5>
                                                <h5 className="mb-1">Temp: <b>{checkoutSlipData?.temperature ?? "N/A"}<sup>&#176;</sup>F</b>, BP: <b>{checkoutSlipData?.bp ?? "N/A"}</b>, Pulse: <b>{checkoutSlipData?.pulse ?? "N/A"} BPM.</b></h5>
                                            </div>

                                        </div>
                                        <div className=" ">
                                            <div className="text-start" >
                                                <div className="d-flex align-items-center mb-1">
                                                    <Avatar
                                                        src={base64Image?.clinicImage}
                                                        alt={checkoutSlipData?.clinicName ?? ""}
                                                        style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                                                    >
                                                        {!base64Image?.clinicImage && checkoutSlipData?.clinicName?.[0]?.toUpperCase()}
                                                    </Avatar>
                                                    <h4 className="mb-0 ms-2">{checkoutSlipData?.clinicName ?? "N/A"}</h4>
                                                </div>
                                                <h5 className="mb-1">{fullFirstAddress1}</h5>
                                                <h5 className="mb-1">{fullFirstAddress}</h5>
                                                <h5 className="mb-1">{fullLastAddress}</h5>
                                            </div>
                                            <div className="  d-flex   flex-column mt-3">
                                                <div className="d-flex justify-content-end">
                                                    <div dangerouslySetInnerHTML={{ __html: checkoutSlipData?.barcode }} />

                                                </div>
                                                <div className=" mt-2">
                                                    <h5 className="mb-1"><b>Date: {moment(checkoutSlipData?.apptStartDate).format("DD-MMM-YYYY")}, {moment(checkoutSlipData?.apptStartDate).format("hh:mm A")}</b></h5>
                                                    <h5 className="mb-1">Height: <b>{checkoutSlipData?.height ?? "N/A"} cm</b>, Weight: <b>{checkoutSlipData?.weight ?? "N/A"} kg</b> </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" patient_details  d-flex align-items-end justify-content-between mt-md-0 mt-3">
                                    </div>
                                    <hr className="hr my-2" />
                                    <div className="d-flex justify-content-start align-items-center my-2">
                                        <img src={require("../../Assets/UploadDocumentImage/Doctor.png")} className="icone  me-3" alt="" />
                                        <h5 className="mb-0">
                                            <b>Symptoms:</b>{" "}
                                            {checkoutSlipData?.symptom?.length > 0
                                                ? checkoutSlipData.symptom.map((item, index) => (
                                                    <span key={index}>
                                                        {item?.symptoms}
                                                        {checkoutSlipData.symptom.length > index + 1 ? ", " : ""}
                                                    </span>
                                                ))
                                                : "N/A"}
                                        </h5>
                                    </div>
                                    <hr className="hr my-2" />
                                    {
                                        checkoutSlipData?.rx?.length > 0 && <>
                                            <div className="my-2">
                                                <img src={require("../../Assets/UploadDocumentImage/prescription.png")} className="icone  " alt="" />
                                                <table class="table table-bordered ">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ backgroundColor: "transparent" }} scope="col"></th>
                                                            <th style={{ backgroundColor: "transparent" }} scope="col">Medicine Name</th>
                                                            <th className="text-center" style={{ backgroundColor: "transparent" }} scope="col">Dosage</th>
                                                            <th className="text-center" style={{ backgroundColor: "transparent" }} scope="col">Duration</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            checkoutSlipData?.rx?.map((cur, index) => {
                                                                return <tr>
                                                                    <td >{index + 1}</td>
                                                                    <td >{`${cur?.medicineType ?? ""}, ${cur?.medicineName ?? ""}, ${cur?.doseAmount ?? ""}${cur?.doseType ?? ""}`}</td>
                                                                    <td className="text-center">
                                                                        {Dosage(cur)} <br />
                                                                        ({cur?.medicineIntakeTime !== "CUSTOM" ? cur?.medicineIntakeTime : cur?.medicineIntakeCustomTime})
                                                                    </td>
                                                                    <td className="text-center">{cur?.medicineIntakeDurationAmount + " " + cur?.medicineIntakeDurationType}
                                                                        <br />
                                                                        {`(Tot: ${cur?.totalTablets} ${cur?.tabletType})`}
                                                                    </td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr className="hr my-2" />
                                        </>
                                    }
                                    <div className="d-flex  justify-content-start align-items-center my-2">
                                        <img src={require("../../Assets/UploadDocumentImage/blood-sample.png")} className="icone  me-3" alt="" />
                                        <h5 className="mb-0">
                                            <b>Test Required: </b>
                                            {checkoutSlipData?.tests?.length > 0
                                                ? checkoutSlipData.tests.map((item, index) => (
                                                    <span key={index}>
                                                        {item?.testsName}
                                                        {checkoutSlipData.tests.length > index + 1 ? ", " : ""}
                                                    </span>
                                                ))
                                                : "N/A"}
                                        </h5>
                                    </div>
                                    <hr className="hr my-2" />
                                    <div className="d-flex  justify-content-start align-items-center ">
                                        <h5 className="mb-0">
                                            <b>Notes: </b>
                                            {
                                                [...new Set(checkoutSlipData?.rx?.map(cur => cur?.notes).filter(Boolean))]?.length > 0
                                                    ? [...new Set(checkoutSlipData.rx.map(cur => cur?.notes).filter(Boolean))].map((item, index, array) => (
                                                        <span key={index}>
                                                            {item}
                                                            {array.length > index + 1 ? ", " : ""}
                                                        </span>
                                                    ))
                                                    : "N/A"
                                            }
                                        </h5>
                                    </div>
                                    <hr className="hr my-2" />
                                    <div className="d-flex  justify-content-start align-items-center ">
                                        <h5 className="mb-0"><b>Follow-Up: </b>{checkoutSlipData?.followUpDate ? moment(checkoutSlipData?.followUpDate)?.format("DD/MM/YYYY") : "N/A"} </h5>
                                    </div>
                                    <hr className="hr my-2" />
                                </div>
                                {
                                    checkoutCount > 1 && <>
                                        {shouldBreakPage && <div className="page-break-before"></div>}
                                        <div className="">
                                            <h5 className="mb-0"><b>Charts</b></h5>
                                            <div className="border d-flex flex-wrap  mx-0 px-0 pt-3" style={{ gap: "5px" }} >
                                                <div className=" border mb-3" style={{ height: 250, width: 228 }}>
                                                    <ResponsiveContainer width="100%" height="92%">
                                                        <LineChart
                                                            data={insightsPatientTemp?.map((cur) => ({ ...cur, temperature: parseFloat(parseFloat(cur?.temperature).toFixed(2)), }))}
                                                            margin={{
                                                                top: 10,
                                                                right: 20,
                                                                left: -20,
                                                                bottom: 5
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="recordDate" />
                                                            <YAxis />
                                                            <Tooltip
                                                                formatter={(value) => `${value}°`}
                                                                labelFormatter={(label) => `Date: ${label}`}
                                                            />
                                                            <Legend />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="temperature"
                                                                stroke="#8884d8"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                        </LineChart>
                                                    </ResponsiveContainer>

                                                    <div className="border-top text-center">
                                                        <span>Temp</span>
                                                    </div>

                                                </div>
                                                <div className="  border mb-3" style={{ height: 250, width: 228 }}>
                                                    <ResponsiveContainer width="100%" height="92%" >
                                                        <LineChart

                                                            data={insightsPatientBp?.map((cur) => ({ ...cur, sys: Number(cur?.sys), dia: Number(cur?.dia), pulse: Number(cur?.pulse) }))}
                                                            margin={{
                                                                top: 10,
                                                                right: 20,
                                                                left: -20,
                                                                bottom: 5,
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="recordDate" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Line type="monotone" dataKey="sys" stroke="#8884d8" activeDot={{ r: 8 }} />
                                                            <Line type="monotone" dataKey="dia" stroke="#82ca9d" />
                                                            <Line type="monotone" dataKey="pulse" stroke="red" />
                                                        </LineChart>
                                                    </ResponsiveContainer>
                                                    <div className="border-top text-center">
                                                        <span>BP</span>
                                                    </div>
                                                </div>
                                                <div className="  border mb-3" style={{ height: 250, width: 229 }}>
                                                    <ResponsiveContainer width="100%" height="92%" >
                                                        <LineChart
                                                            data={insightsPatientBMI?.map((cur) => ({ ...cur, bmi: parseFloat(parseFloat(cur?.bmi).toFixed(2)), }))}
                                                            margin={{
                                                                top: 10,
                                                                right: 20,
                                                                left: -20,
                                                                bottom: 5,
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="recordDate" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Line type="monotone" dataKey="bmi" stroke="#8884d8" activeDot={{ r: 8 }} />
                                                        </LineChart>
                                                    </ResponsiveContainer>
                                                    <div className="border-top text-center">
                                                        <span>BMI</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </>

                                }

                                <div className="d-flex justify-content-end flex-column align-items-end py-3 checkout_slip_footer">
                                    <h4 >{doctorName}</h4>
                                    <h5 className="mb-1" >{doctorDegrees}</h5>
                                    <img src={base64Image?.Signature} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CheckoutSlip;
